import React, {useEffect, useState} from 'react';
import {word} from "../word.js";
import BlueButton from "./BlueButton/BlueButton.js";
import {Col, Modal, Row} from "react-bootstrap";
import Api from "../Api.js";
import {useDispatch, useSelector} from "react-redux";
import moment from "moment";
import {REACT_APP_API_URL} from '../config.js';
import {Autocomplete, TextField} from "@mui/material";
import Loader from "./BlueButton/Loader.js";
import TextAreaTask from "./TaskSingleComponents/TextAreaTask.js";
import DropDownTask from "./TaskSingleComponents/DropDownTask.js";
import CheckboxFilter from "./CheckboxFilter.js";
import SuccessToast from "./BlueButton/SuccessToast.js";
import ErrorToast from "./BlueButton/ErrorToast.js";


function AddTask({onHide, show, subTask, task, getData}) {
    const login = useSelector((state) => state.manager.employee);
    const account = useSelector((state) => state.task.accountant);
    const companies = useSelector((state) => state.task.companies);
    const managers = useSelector((state) => state.task.managers);

    const [disabled, setDisabled] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [forMe, setForMe] = useState(false);
    const [templateId, setTemplateId] = useState(0);
    const [visibleForClient, setVisibleForClient] = useState(true);
    const [endDate, setEndDate] = useState(null);

    const [limitData, setLimitData] = useState({
        organization: [],
        taskTemplate: [],
        manager: [],
        stuff: [],
    });
    const [images, setImages] = useState([]);
    const [form, setForm] = useState([
        {key: 'name', value: "", errorMessage: "empty_error", type: "textarea", label: ""},
        {key: 'text', value: "", errorMessage: "empty_error", type: "textarea", label: ""},
        {
            key: 'company',
            value: [],
            option: "organization",
            errorMessage: "select_error",
            type: "dropDown",
            label: "",
            valid: true
        },
        {key: "manager", value: "", option: "manager", errorMessage: "select_error", type: "dropDown", label: ""},
        {
            key: 'accountant',
            value: localStorage.getItem('profession') === "accountant" ? [{
                value: login.id,
                label: login.user.first_name + ' ' + login.user.last_name
            }] : "",
            option: "stuff",
            errorMessage: "select_error",
            type: "dropDown",
            label: ""
        }
    ]);

    const handleChangeDate = e => setEndDate(e.target.value);
    useEffect(() => {
        (async () => {
            const template = await Api.taskTemplate()
            setLimitData({
                organization: companies.map(s => ({...s, url: REACT_APP_API_URL + 'manager-company/' + s.id + '/'})),
                taskTemplate: template.data.results,
                manager: managers,
                stuff: account.map(s => ({value: s.id, label: s.user.first_name + ' ' + s.user.last_name}))
            })
        })()
    }, [account,managers,companies])

    const submit = async () => {
        try {
            let formData = new FormData();
            let creator = login.user.url;
            let multiAccountant = forMe ? [] : form[form.length - 1].value;
            let createdDate = new Date().toLocaleString("en-US", {timeZone: "Asia/Yerevan"});
            setSubmitted(true);
            images.forEach((image, index) => {
                formData.append(`file${index + 1}`, image, image.name);
            });
            form.forEach(element => {
                if (!element.valid) return;
                formData.append(element.key, element.value);
            });

            formData.append("created_date", moment(createdDate).format("YYYY-MM-DD HH:mm:ss"));
            formData.append("creator", creator);
            formData.append("template_id", templateId);
            formData.append("visible_for_client", visibleForClient);
            if (endDate) {
                formData.append("end_date", moment(endDate).format("YYYY-MM-DD HH:mm:ss"));
            }
            if (subTask) {
                formData.append("parent_task", task.url);
            }
            formData.append("manager", form[3].value || login.url);
            setDisabled(true)
            if (multiAccountant.length > 0) {
                for (const accountant of multiAccountant) {
                    formData.append("accountant", `${REACT_APP_API_URL}accountant/${accountant.value}/`);
                    await Api.createTask(formData);
                }
            } else {
                await Api.createTask(formData);
            }
            await getData();
            setDisabled(false)
            SuccessToast();
            onHide()
        } catch (e) {
            setDisabled(false)
            console.log(e)

            ErrorToast()
        }
    };
    const deletePhoto = (item, setImages) => {
        setImages((prevImages) => prevImages.filter((el) => el.name !== item.name));
    };

    const updateForm = (value) => {
        setForm((prevForm) => {
            return prevForm.map((item) =>
                item.key === "name"
                    ? {...item, value: value ? value.name : "", valid: true}
                    : item
            );
        });

        setTemplateId(value ? value.id : 0);
    };
    const keyPress = async (e) => {
        if (e.key === "Enter") {
            await submit()
        }
    };
    const handleFileChange = (e) => {
        let newFiles = Array.from(e.target.files);
        setImages((prevImages) => [...prevImages, ...newFiles]);
    };

    return (
        <Modal
            {...{onHide, show}}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered


        >
            <Modal.Header className='green-top'>
                <Modal.Title id="contained-modal-title-vcenter"
                             className="w-100 d-flex flex-row justify-content-between">
                    <span>{word.new_recommendations}</span>
                    <div className="tool-tip-cont">
                        <div className="tool-tip">Փակել</div>
                        <i className="fas fa-times" onClick={onHide}/>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className=''>
                    <div className='container'>
                        <Row className="justify-content-center">
                            <Col xs={12} sm={10}>
                                <div className="input-validation">
                                    <Autocomplete
                                        loading={limitData.taskTemplate.length <= 0}
                                        loadingText={<div className="auto-complete-loader"><Loader size={15}/></div>}
                                        id="combo-box-demo"
                                        options={limitData.taskTemplate}
                                        onChange={(e, value) => {
                                            updateForm(value)
                                        }}
                                        getOptionLabel={option => {
                                            return option.name
                                        }}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                label="Ընտրել առաջադրանքի վերնագիր"
                                                variant="outlined" fullWidth
                                                onKeyDown={(e) => {
                                                    keyPress(e)
                                                }}/>
                                        )}
                                    />
                                </div>
                                {form.map((item, index) => {
                                    if (item.type === "textarea") {
                                        return <TextAreaTask key={index} item={item} index={index} setFormData={setForm}
                                                             submitted={submitted}/>
                                    }
                                    if (item.type === "dropDown" && limitData[item.option]) {
                                        return <DropDownTask key={index} item={item} index={index} setFormData={setForm}
                                                             submitted={submitted} limit_data={limitData}
                                                             forMe={forMe} setForMe={setForMe}/>
                                    }
                                    return null
                                })}

                                <div className='input-validation'>
                                    <TextField
                                        // disabled
                                        id="datetime-local"
                                        label="Վերջնաժամկետ"
                                        type="datetime-local"
                                        onChange={handleChangeDate}
                                        variant="outlined"
                                        InputProps={{inputProps: {min: moment(new Date()).format("YYYY-MM-DDTHH:mm")}}}
                                        sx={{width: 250}}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>
                                <CheckboxFilter title="Տեսանելի բոլորի համար"
                                                my_task={visibleForClient}
                                                onChange={() => {
                                                    setVisibleForClient(!visibleForClient)
                                                }}
                                />
                                <div className='img-icon-cont'>
                                    <div className='img-cont'>
                                        {images.map((item, index) => {
                                            return <div className='img' key={index}>
                                                <span
                                                    className={(item.type === "image/jpeg") || (item.type === "image/png") ? 'icon-Photos' : "icon-files-empty"}/>
                                                <span className='images-name'>{item.name}</span>
                                                <i className="fas fa-times" onClick={() => deletePhoto(item)}/>
                                            </div>
                                        })}
                                    </div>
                                    <label>
                                        <span className='icon-Attachment'/>
                                        <input type="file" multiple className='input-icon'
                                               onChange={(e) => handleFileChange(e)}/>
                                    </label>

                                </div>
                                <div className='line-blue'/>
                                {disabled ? <div className="disable-loader"><Loader size={30}/></div> : null}
                                <div className='button-line'>
                                    <BlueButton disabled={disabled}
                                                title={word.create}
                                                buttonStyle={!disabled ? "blue-button" : "blue-button blue-button-disabled"}
                                                onChangeValue={() => submit()}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>

            </Modal.Body>
        </Modal>
    );
}

export default AddTask;